// extracted by mini-css-extract-plugin
export default {"employeeVocations":"employee-vocations_employeeVocations__vyBt8","empty":"employee-vocations_empty__s0M1L"};